import { IOfferChatV2Schema, TDealType, TOfferCategory, TOfferType } from '@cian/chats-api';

import { mapOfferGeoV2VersionToV1 } from './mapGeo';
import { TSingleChatV2Offer } from '../../types/chatList';
import { TOffer } from '../../types/offer';
import { formatOfferPhone } from '../getOfferPhone';

export const mapOfferV2VersionToV1 = (offer?: IOfferChatV2Schema | TSingleChatV2Offer): TOffer | undefined => {
  if (!offer || !offer.id) {
    return undefined;
  }

  const isCategory = (category?: string): category is TOfferCategory => {
    return true;
  };
  const isDealType = (dealType?: string): dealType is TDealType => {
    return true;
  };
  const isOfferType = (offerType?: string): offerType is TOfferType => {
    return true;
  };

  return {
    category: isCategory(offer.category) ? (offer.category as TOfferCategory) : 'flatSale',
    dealType: isDealType(offer.dealType) ? (offer.dealType as TDealType) : 'sale',
    formattedFullInfo: offer.formattedFullInfo,
    isFromBuilder: offer.fromDeveloper,
    geo: mapOfferGeoV2VersionToV1(offer.geo),
    id: offer.id,
    offerType: isOfferType(offer.offerType) ? (offer.offerType as TOfferType) : 'flat',
    phones: offer.phone ? [formatOfferPhone(offer.phone)] : [],
    photos: offer.photoUrl
      ? [
          {
            isDefault: true,
            miniUrl: offer.photoUrl,
          },
        ]
      : [],
    removalFromPublicationDate: offer.removalFromPublicationDate,
    userId: offer.userId,
    fullUrl: offer.fullUrl || '',
    pricePerUnitAreaPerYearRur: 0,
    priceTotalPerMonthRur: 0,
    totalArea: '',
    analyticsUrl: offer.analyticsUrl,
  };
};
